import styled from 'styled-components';
import { Button, Typography, Collapse, Row } from 'antd';

const { Text } = Typography;

export const CollapsContainer = styled(Collapse)`
  border: none;
  background-color: #fff;
  .ant-collapse-content {
    border: none;
    background: #f2f2f2;
  }
  .ant-collapse-header {
    border-radius: 2px;
    padding: 17px 26px 17px 28px !important;
    align-items: center !important;

    .ant-collapse-extra {
      margin-inline-start: auto;
      margin-right: 16px;
    }
  }

  .ant-collapse-content-box {
    padding: 0 26px 17px 28px !important;
  }

  .ant-collapse-item,
  .site-collapse-custom-panel {
    margin-bottom: 30px;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.16));
    overflow: hidden;
    border: 0px;
    border-radius: 8px;
  }
  .open {
    background: #f7f8f9;
  }
  .close {
    background: #f2f2f2;
  }
`;

export const Header = styled.div``;

export const BoxTitle = styled.div`
  font-size: 14px;
`;

export const Title = styled(Text)`
  font-size: 14px;
  line-height: 22px;
  margin: 0;
  padding: 0;
  font-weight: bold;
  color: ${props => props.color || '#828282'};
  > pre {
    font-size: 14px;
    background: transparent;
    border: none;
    font-family: Roboto;
    padding: 0;
  }
`;

export const BoxSubTitle = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const TextDivergencia = styled(Text)`
  font-size: 14px;
  color: #d42929;
`;

export const Buttom = styled(Button)`
  border-radius: 0;
  border: none;
  color: #fff;
  padding: 0;
`;

export const Content = styled.div`
  padding: 12px 8px 12px 15px;
  background-color: #f7f8f9;
  border-radius: 2px;
`;

export const TitleContent = styled(Text)`
  font-size: 14px;
  color: ${props => props.red || '#707070'};
  font-weight: ${props => props.weight || 'nomal'};
  pre {
    border: none;
    font-size: 14px;
    background: transparent;
    font-family: Roboto;
    padding: 0;
  }
`;

export const SpaceCusto = styled.div`
  .openCollaps {
    transform: rotate(0deg);
    transition: transform 400ms ease-in-out;
    cursor: pointer;
  }
  .openCollaps.active {
    transform: rotate(180deg);
    transition: transform 400ms ease-in-out;
    cursor: pointer;
  }
`;

export const RowStyles = styled(Row)`
  .ant-select.ant-select-single.ant-select-show-arrow {
    background: #f2f2f2 !important;
    border-radius: 2px !important;
  }
  .ant-select-selector {
    background: #f2f2f2 !important;
    line-height: 16px;
    border: none !important;
    font-weight: normal;
    line-height: 16px;
    cursor: pointer;
    &:hover {
      border: none !important;
      line-height: 16px;
      font-weight: normal;
      cursor: pointer;
    }
  }
  .ant-select,
  .ant-select-multiple,
  .ant-select-show-arrow,
  .ant-select-show-search {
    border: none;
    border-radius: 2px;
    padding: 4px;
    background: #f2f2f2;
    .ant-select-selection-overflow-item,
    .ant-select-multiple,
    .ant-select-selection-item {
      border: none;
      flex-direction: row-reverse;
      .ant-select-selection-item-remove {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding-right: 2px;
        .anticon,
        .anticon-close {
          border-radius: 50%;
          border: ${props => `solid ${props?.iconColor || '#24a95d'} 1px`};
          padding: 2px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        }
        svg {
          color: ${props => props?.iconColor || '#24a95d'};
          font-weight: border;
        }
      }
      .ant-select-selection-item-content {
        padding: auto 4px;
        margin-left: 3px;
      }
    }
    .ant-select-arrow {
      svg {
        color: #707070;
      }
    }
  }
`;
